module.exports = __webpack_public_path__ + "static/media/background2.49dd42b9.jpg";